import React, { useState, useEffect, useContext } from 'react';
import { PermissoesSidebarContext } from '../Context/permissoesSidebar';
import { useHistory, useLocation } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import axios from 'axios';
import CadastroFormDrawer from '../Components/CadastroFormDrawer/CadastroFormDrawer';
import './usuarios.css';
import ListaUsuarios from '../Components/ListaUsuarios/listaUsuarios';
import verificandoToken from '../../FuncoesGerais/VerificarToken';
import { ensureProtocol } from '../../config/backend';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import { fetchGruposUsuarioAtivos } from '../../api/gruposUsuario';
import { checkUsuarioPorEmail, vincularUsuarioEmpresa } from '../../api/usuarios';
import { fetchEmpresas } from '../../api/empresas';

function podeAcessarCadastroUsuarios(permissoes) {
    if (permissoes == null) return true;
    if (permissoes.CADASTROS_USUARIOS === true) return true;
    if (permissoes.CADASTROS === true) return true;
    return false;
}

function Usuarios() {
    const history = useHistory();
    const location = useLocation();
    const { permissoes, loading: loadingPermissoes } = useContext(PermissoesSidebarContext);
    const editIdFromState = location.state?.editId;

    const verificar = async () => {
        const resultado = await verificandoApp("ATENDENTE");
        if (!resultado) history.push("/");
    };

    const [data, setData] = useState([]);
    const [descr, setDescr] = useState('');
    const [formDrawerOpen, setFormDrawerOpen] = useState(false);

    const [usrEml, setUsrEml] = useState('');
    const [usrPwd, setUsrPwd] = useState('');
    const [usrLgn, setUsrLgn] = useState('');
    const [usrGru, setUsrGru] = useState('');
    const [usuSit, setUsuSit] = useState('');
    const [usrAre, setUsrAre] = useState('');
    const [usuSeq, setUsuSeq] = useState('');
    const [perAltUsu, setPerAltUsu] = useState('');
    const [equipex, setEquipex] = useState('');
    const [usrConPwd, setUsrConPwd] = useState('');
    const [usrNomCpl, setUsrNomCpl] = useState('');
    const [empresaCliente, setEmpresaCliente] = useState('');
    const [pesGraImp, setPesGraImp] = useState('');
    const [equitix, setEquitix] = useState('');
    const [ehDesenvolvedor, setEhDesenvolvedor] = useState(0);
    const [ehSuporte, setEhSuporte] = useState(0);
    const [updIns, setUpdIns] = useState('I');
    const [mensagem, setMensagem] = useState('');
    const [placeId] = useState("Sequência para edição ou em branco para novo");
    const [grupos, setGrupos] = useState([]);
    const [filtroStatus, setFiltroStatus] = useState('todos');
    const [showModalEmailExiste, setShowModalEmailExiste] = useState(false);
    const [usuarioExistente, setUsuarioExistente] = useState(null);
    const [empresaAtualNome, setEmpresaAtualNome] = useState('');
    const [showModalGrupoVinculo, setShowModalGrupoVinculo] = useState(false);
    const [grupoVinculo, setGrupoVinculo] = useState('USU');
    const [loadingEmailCheck, setLoadingEmailCheck] = useState(false);
    const [loadingVincular, setLoadingVincular] = useState(false);
    const [mensagemVinculo, setMensagemVinculo] = useState('');

    const buscandoUsuario = async (codUsu) => {
        verificandoToken();
        if (!codUsu) return;
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/usuarios", {
                headers: { Authorization: `${token}` },
                params: { codUsu: codUsu }
            });
            if (response.data.length > 0) {
                setUpdIns('U');
                setUsuSeq(response.data[0].USUSEQ);
                setUsrNomCpl(response.data[0].USRNOMCPL || '');
                setEmpresaCliente(response.data[0].empresa_cliente || '');

                setUsrPwd('');
                setUsrConPwd('');
                setUsrEml(response.data[0].USREML || '');
                setUsrLgn(response.data[0].USRLGN || '');
                setUsrGru(response.data[0].USRGRU || '');
                setUsuSit(response.data[0].USRSIT || '');
                setUsrAre(response.data[0].USRARE || '');
                setPesGraImp(response.data[0].PESGRAIMP || '');
                setEquitix(response.data[0].EQUITIX || '');
                setEquipex(response.data[0].EQUIPEX || '');
                setPerAltUsu(response.data[0].PERALTUSU || '');
                setEhDesenvolvedor(response.data[0].eh_desenvolvedor != null ? Number(response.data[0].eh_desenvolvedor) : 0);
                setEhSuporte(response.data[0].eh_suporte != null ? Number(response.data[0].eh_suporte) : 0);
            } else {
                setUpdIns('I');
                setUsuSeq('');
                setUsrNomCpl(''); setUsrPwd(''); setUsrConPwd(''); setUsrEml(''); setUsrLgn('');
                setEmpresaCliente('');
                setUsrGru(''); setUsuSit(''); setUsrAre(''); setPesGraImp(''); setEquitix(''); setEquipex(''); setPerAltUsu('');
                setEhDesenvolvedor(0); setEhSuporte(0);
            }
        } catch (e) { console.error(e); }
    };

    const limparForm = () => {
        setUpdIns('I');
        setUsuSeq(''); setUsrNomCpl(''); setUsrPwd(''); setUsrConPwd(''); setUsrEml(''); setUsrLgn('');
        setEmpresaCliente('');
        setUsrGru(''); setUsuSit(''); setUsrAre(''); setPesGraImp(''); setEquitix(''); setEquipex(''); setPerAltUsu('');
        setEhDesenvolvedor(0); setEhSuporte(0);
        setMensagem('');
    };

    const verificarCampos = () => {
        if (!usrNomCpl.trim()) { setMensagem("Nome completo obrigatório!"); return false; }
        if (!usrEml.trim()) { setMensagem("E-mail obrigatório!"); return false; }
        if (updIns === 'I') {
            if (!usrPwd.trim()) { setMensagem("Senha obrigatória!"); return false; }
            if (usrPwd !== usrConPwd) { setMensagem("Senhas não conferem!"); return false; }
        } else {
            if (usrPwd.trim() || usrConPwd.trim()) {
                if (usrPwd !== usrConPwd) { setMensagem("Senhas não conferem!"); return false; }
            }
        }
        if (!usrGru) { setMensagem("Selecione um grupo!"); return false; }
        const grupoSelecionado = grupos.find((g) => g.codigo === usrGru);
        const exigeArea = grupoSelecionado && (grupoSelecionado.papel === 'analista' || grupoSelecionado.papel === 'administrador');
        if (exigeArea && !usrAre) {
            setMensagem("Área obrigatória para este grupo (papel Analista/Administrador)!"); return false;
        }
        if (!usuSit) { setMensagem("Selecione situação!"); return false; }
        setMensagem('');
        return true;
    };

    const montaObjeto = () => {
        const obj = {
            USUSEQ: usuSeq,
            USREML: usrEml,
            USRPWD: usrPwd,
            USRNOMCPL: usrNomCpl,
            empresa_cliente: empresaCliente.trim() || null,
            USRLGN: usrLgn,
            USRGRU: usrGru,
            USRSIT: usuSit,
            USRARE: usrAre,
            PESGRAIMP: pesGraImp || '1',
            EQUITIX: equitix || (grupos.find((g) => g.codigo === usrGru)?.papel === 'analista' || grupos.find((g) => g.codigo === usrGru)?.papel === 'administrador' ? "S" : "N"),
            EQUIPEX: equipex,
            PERALTUSU: perAltUsu,
            eh_desenvolvedor: ehDesenvolvedor ? 1 : 0,
            eh_suporte: ehSuporte ? 1 : 0
        };
        return obj;
    };

    const empresaIdAtual = () => Number(localStorage.getItem('empresa_id')) || 1;

    const verificarEmailExistente = async () => {
        if (updIns !== 'I' || !usrEml || !String(usrEml).trim()) return;
        setLoadingEmailCheck(true);
        setUsuarioExistente(null);
        setShowModalEmailExiste(false);
        try {
            verificandoToken();
            const resultado = await checkUsuarioPorEmail(usrEml.trim());
            if (resultado.exists && resultado.usuario) {
                const empId = empresaIdAtual();
                let nomeEmpresa = `ID ${empId}`;
                try {
                    const list = await fetchEmpresas();
                    const emp = Array.isArray(list) && list.find((e) => Number(e.id) === empId);
                    if (emp && emp.nome) nomeEmpresa = emp.nome;
                } catch (_) {}
                setEmpresaAtualNome(nomeEmpresa);
                setUsuarioExistente(resultado.usuario);
                setShowModalEmailExiste(true);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoadingEmailCheck(false);
        }
    };

    const confirmarIncluirNaEmpresa = () => {
        setShowModalEmailExiste(false);
        setShowModalGrupoVinculo(true);
        setGrupoVinculo('USU');
        setMensagemVinculo('');
    };

    const cancelarIncluirNaEmpresa = () => {
        setShowModalEmailExiste(false);
        setUsuarioExistente(null);
    };

    const confirmarGrupoEVincular = async () => {
        const usuId = usuarioExistente?.USUSEQ ?? usuarioExistente?.ususeq;
        if (!usuarioExistente || !usuId) return;
        setLoadingVincular(true);
        setMensagemVinculo('');
        verificandoToken();
        try {
            await vincularUsuarioEmpresa(usuId, empresaIdAtual(), grupoVinculo);
            setShowModalGrupoVinculo(false);
            setUsuarioExistente(null);
            limparForm();
            setFormDrawerOpen(false);
            fetchData();
        } catch (e) {
            setMensagemVinculo(e?.response?.data?.error || e?.response?.data?.message || 'Erro ao vincular usuário à empresa.');
        } finally {
            setLoadingVincular(false);
        }
    };

    const codUsuLogado = parseInt(localStorage.getItem('codUsu') || '0', 10);
    const ehEdicaoDoProprioUsuario = updIns === 'U' && Number(usuSeq) === codUsuLogado;
    const allowSelfUserEdit = loadingPermissoes || podeAcessarCadastroUsuarios(permissoes);
    const bloqueiaEdicaoPropria = ehEdicaoDoProprioUsuario && !allowSelfUserEdit;

    const inserindoUsuario = async () => {
        if (bloqueiaEdicaoPropria) return;
        if (!verificarCampos()) return;
        const o = montaObjeto();
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            if (updIns === 'I') {
                await axios.post(ensureProtocol(localStorage.getItem("ipBackend2")) + "/usuarios", o, { headers: { Authorization: `${token}` } });
            } else {
                await axios.put(ensureProtocol(localStorage.getItem("ipBackend2")) + "/usuarios/completo", o, { headers: { Authorization: `${token}` } });
            }
            setMensagem('');
            limparForm();
            setFormDrawerOpen(false);
            fetchData();
        } catch (e) {
            setMensagem('Erro ao salvar');
        }
    };

    const fetchData = async () => {
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            const baseUrl = ensureProtocol(localStorage.getItem("ipBackend2")) + "/usuarios";
            const hasSearch = descr && descr.trim();
            const response = hasSearch
                ? await axios.get(baseUrl + "/listagem", { headers: { Authorization: `${token}` }, params: { descr: descr.trim() } })
                : await axios.get(baseUrl + "/todos", { headers: { Authorization: `${token}` } });
            const raw = Array.isArray(response.data) ? response.data : [];
            const lista = raw.map(u => ({
                usuSeq: u.USUSEQ ?? u.ususeq,
                usrNomCpl: u.USRNOMCPL ?? u.usrnomcpl ?? '',
                empresaCliente: u.empresa_cliente ?? '',
                usrLgn: u.USRLGN ?? u.usrlgn ?? '',
                usrSit: u.USRSIT ?? u.usrsit ?? ''
            }));
            setData(lista);
        } catch (e) { console.error(e); setData([]); }
    };

    useEffect(() => {
        verificar();
        fetchData();
        (async () => {
            const list = await fetchGruposUsuarioAtivos();
            setGrupos(list);
        })();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (editIdFromState) {
            buscandoUsuario(editIdFromState).then(() => setFormDrawerOpen(true));
        }
    }, [editIdFromState]);

    const handleEdit = (id) => {
        buscandoUsuario(id);
        setFormDrawerOpen(true);
    };

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <div className="container-fluid titulo cadastro-unificado">
                    <div className="page-header">
                        <h1>Usuários</h1>
                        <div className="toolbar flex-wrap">
                            <div className="input-group input-group-sm" style={{ maxWidth: 280 }}>
                                <input value={descr} onChange={(e) => setDescr(e.target.value)} type="text" className="form-control" placeholder="Pesquisar" />
                                <button onClick={fetchData} className="btn btn-secondary" type="button"><i className="fas fa-search" /></button>
                            </div>
                            <select value={filtroStatus} onChange={(e) => setFiltroStatus(e.target.value)} className="form-control form-control-sm" style={{ maxWidth: 160 }} title="Filtrar por situação">
                                <option value="todos">Todos</option>
                                <option value="A">Ativos</option>
                                <option value="I">Inativos</option>
                            </select>
                            <button type="button" className="btn btn-primary btn-sm" onClick={() => { limparForm(); setFormDrawerOpen(true); }}>
                                Novo usuário
                            </button>
                        </div>
                    </div>

                    <CadastroFormDrawer
                        open={formDrawerOpen}
                        onClose={() => { limparForm(); setFormDrawerOpen(false); }}
                        title={updIns === 'U' ? 'Editar usuário' : 'Novo usuário'}
                    >
                        <div className="cadastro-form-drawer-form">
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="form-group">
                                        <label>Sequência (edição)</label>
                                        <input type="text" onChange={(e) => buscandoUsuario(e.target.value)} className="form-control form-control-sm" placeholder={placeId} />
                                    </div>
                                    <div className="form-group">
                                        <label>Nome completo</label>
                                        <input value={usrNomCpl} onChange={(e) => setUsrNomCpl(e.target.value)} className="form-control form-control-sm" />
                                    </div>
                                    <div className="form-group">
                                        <label>Empresa ou CNPJ</label>
                                        <input
                                            value={empresaCliente}
                                            onChange={(e) => setEmpresaCliente(e.target.value)}
                                            className="form-control form-control-sm"
                                            placeholder="Nome da empresa ou CNPJ do solicitante"
                                            maxLength={120}
                                        />
                                        <small className="text-muted">Usado em relatórios de atendimento por empresa.</small>
                                    </div>
                                    <div className="form-group">
                                        <label>Login</label>
                                        <input value={usrLgn} onChange={(e) => setUsrLgn(e.target.value)} className="form-control form-control-sm" />
                                    </div>
                                    <div className="form-group">
                                        <label>E-mail</label>
                                        <input
                                            value={usrEml}
                                            onChange={(e) => setUsrEml(e.target.value)}
                                            onBlur={verificarEmailExistente}
                                            type="email"
                                            className="form-control form-control-sm"
                                            placeholder={updIns === 'I' ? 'Ao sair do campo, verifica se já existe no sistema' : ''}
                                        />
                                        {loadingEmailCheck && <small className="text-muted">Verificando...</small>}
                                    </div>
                                    <div className="form-group">
                                        <label>Senha {updIns === 'U' && '(deixe em branco para não alterar)'}</label>
                                        <input value={usrPwd} onChange={(e) => setUsrPwd(e.target.value)} type="password" className="form-control form-control-sm" placeholder={updIns === 'U' ? 'Nova senha (opcional)' : 'Senha'} />
                                    </div>
                                    <div className="form-group">
                                        <label>Confirme senha</label>
                                        <input value={usrConPwd} onChange={(e) => setUsrConPwd(e.target.value)} type="password" className="form-control form-control-sm" placeholder={updIns === 'U' ? 'Repita a nova senha' : 'Confirme a senha'} />
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="form-group">
                                        <label>Grupo</label>
                                        <select value={usrGru} onChange={(e) => setUsrGru(e.target.value)} className="form-control form-control-sm">
                                            <option value="">Escolher...</option>
                                            {grupos.map((g) => <option key={g.id} value={g.codigo}>{g.nome}</option>)}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Situação</label>
                                        <select value={usuSit} onChange={(e) => setUsuSit(e.target.value)} className="form-control form-control-sm">
                                            <option value="">Escolher...</option>
                                            <option value="A">Ativo</option>
                                            <option value="I">Inativo</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Área</label>
                                        <select value={usrAre} onChange={(e) => { setUsrAre(e.target.value); setEquitix("S"); }} className="form-control form-control-sm">
                                            <option value="">Escolher...</option>
                                            <option value="S">Sistema</option>
                                            <option value="I">Infraestrutura</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Pode alterar solicitante</label>
                                        <select value={perAltUsu} onChange={(e) => setPerAltUsu(e.target.value)} className="form-control form-control-sm">
                                            <option value="">Escolher...</option>
                                            <option value="S">Sim</option>
                                            <option value="N">Não</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Peso prioridade</label>
                                        <input value={pesGraImp} onChange={(e) => setPesGraImp(e.target.value)} className="form-control form-control-sm" placeholder="1 a 10" />
                                    </div>
                                    <div className="form-group">
                                        <label>Equipe visualização</label>
                                        <input value={equipex} onChange={(e) => setEquipex(e.target.value)} className="form-control form-control-sm" />
                                    </div>
                                    <div className="form-group">
                                        <label className="d-flex align-items-center gap-2">
                                            <input type="checkbox" checked={!!ehDesenvolvedor} onChange={(e) => setEhDesenvolvedor(e.target.checked ? 1 : 0)} />
                                            É desenvolvedor
                                        </label>
                                        <small className="text-muted">Vê apenas chamados de tipos que usam sprint.</small>
                                    </div>
                                    <div className="form-group">
                                        <label className="d-flex align-items-center gap-2">
                                            <input type="checkbox" checked={!!ehSuporte} onChange={(e) => setEhSuporte(e.target.checked ? 1 : 0)} />
                                            É suporte
                                        </label>
                                        <small className="text-muted">Vê apenas chamados de tipos sem sprint.</small>
                                    </div>
                                </div>
                            </div>
                            {bloqueiaEdicaoPropria && (
                                <div className="alert alert-warning py-2 mb-2">Você não pode alterar seu próprio cadastro. As alterações não serão salvas.</div>
                            )}
                            {mensagem && <div className="alert alert-danger py-2 mb-2">{mensagem}</div>}
                            <div className="cadastro-form-drawer-form__actions">
                                <button onClick={() => { limparForm(); setFormDrawerOpen(false); }} type="button" className="btn btn-secondary btn-sm">Cancelar</button>
                                <button onClick={inserindoUsuario} type="button" className="btn btn-primary btn-sm" disabled={bloqueiaEdicaoPropria} title={bloqueiaEdicaoPropria ? 'Não é permitido alterar o próprio cadastro' : ''}>Salvar</button>
                            </div>
                        </div>
                    </CadastroFormDrawer>

                    <ListaUsuarios arrayUsuarios={filtroStatus === 'todos' ? data : data.filter((u) => (u.usrSit || '') === filtroStatus)} onEdit={handleEdit} usuarioLogadoId={codUsuLogado} allowEditOwnUser={allowSelfUserEdit} />

                    {showModalEmailExiste && usuarioExistente && (
                        <div className="modal-overlay" onClick={() => setShowModalEmailExiste(false)}>
                            <div className="modal-card modal-card-usuarios" onClick={(e) => e.stopPropagation()}>
                                <h5 className="mb-3">Usuário já cadastrado</h5>
                                <p className="mb-3">
                                    Usuário com e-mail <strong>{usuarioExistente.USREML ?? usuarioExistente.usreml ?? usrEml}</strong> já cadastrado no sistema.
                                    <br />
                                    Deseja incluir na empresa <strong>{empresaAtualNome}</strong>?
                                </p>
                                <div className="d-flex justify-content-end gap-2">
                                    <button type="button" className="btn btn-secondary btn-sm" onClick={cancelarIncluirNaEmpresa}>Não</button>
                                    <button type="button" className="btn btn-primary btn-sm" onClick={confirmarIncluirNaEmpresa}>Sim</button>
                                </div>
                            </div>
                        </div>
                    )}

                    {showModalGrupoVinculo && usuarioExistente && (
                        <div className="modal-overlay" onClick={() => !loadingVincular && setShowModalGrupoVinculo(false)}>
                            <div className="modal-card modal-card-usuarios" onClick={(e) => e.stopPropagation()}>
                                <h5 className="mb-3">Grupo na empresa</h5>
                                <p className="text-muted small mb-2">Selecione o grupo para identificar em qual sistema a pessoa deve entrar.</p>
                                <div className="form-group mb-3">
                                    <label className="form-label">Grupo</label>
                                    <select className="form-select form-select-sm" value={grupoVinculo} onChange={(e) => setGrupoVinculo(e.target.value)}>
                                        <option value="USU">USU – Usuário / Solicitante</option>
                                        <option value="ANA">ANA – Analista</option>
                                        <option value="ADM">ADM – Administrador</option>
                                    </select>
                                </div>
                                {mensagemVinculo && <div className="alert alert-danger py-2 mb-2">{mensagemVinculo}</div>}
                                <div className="d-flex justify-content-end gap-2">
                                    <button type="button" className="btn btn-secondary btn-sm" onClick={() => setShowModalGrupoVinculo(false)} disabled={loadingVincular}>Cancelar</button>
                                    <button type="button" className="btn btn-primary btn-sm" onClick={confirmarGrupoEVincular} disabled={loadingVincular}>{loadingVincular ? 'Vinculando...' : 'Confirmar'}</button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
}

export default Usuarios;
